// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"348":"76a3","403":"da56","572":"d06a","597":"be34","897":"93a0"}[chunkId] + ".css";
};